module.exports = __webpack_public_path__ + "img/software_hotdocs.67308cec.jpg";